"use client";
import { createContext, useContext, useEffect, ReactNode } from "react";
import { Config } from "../../types/interfaces";
import { useLocalConfig } from "../../config/useLocalConfig";
import { LanguageContext } from "./languageContext";

type ResolvedConfig = ReturnType<typeof useLocalConfig>;

const ConfigContext = createContext<ResolvedConfig | undefined>(undefined);

export const ConfigProvider = ({
	config,
	children,
}: {
	config?: Config;
	children: ReactNode;
}) => {
	const resolvedConfig = useLocalConfig(config);
	const { setPreferredLanguage } = useContext(LanguageContext) || {};

	useEffect(() => {
		setPreferredLanguage?.(resolvedConfig.language);
	}, [resolvedConfig]);

	return <ConfigContext.Provider value={resolvedConfig}>{children}</ConfigContext.Provider>;
};

export const useConfig = (): ResolvedConfig => {
	const context = useContext(ConfigContext);
	if (!context) {
		throw new Error("useConfig must be used within a ConfigProvider");
	}
	return context;
};
